import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

function showImagesSlider() {
	Swiper.use([Autoplay, Navigation, Pagination]);

	new Swiper('.c-default-slider-images__slider-container', {
		loop: false,
		speed: 600,
		autoplay: false,
		slidesPerView: 1,
		spaceBetween: 15,
		navigation: {
			prevEl: '.c-default-slider-images__stories-slider-btn-prev',
			nextEl: '.c-default-slider-images__stories-slider-btn-next',
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});
}

export default showImagesSlider;
